import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';
import { WithTranslations } from 'app/containers/WithTranslations';
import {
    setArrivalLocation,
    requestAutocomplete,
    clearAutocomplete,
    storeCityDetailRequested,
} from 'app/store/actions';
import {
    arrivalCitySelector,
    autocompleteArrivalCurrentByContinentSelector,
    autocompleteArrivalDefaultByContinentSelector,
    errorArrivalSelector,
    autocompleteArrivalLoadingSelector,
} from 'app/store/selectors';
import { emitFieldChangedEvent, emitFieldOpenedEvent, emitFieldClosedEvent } from 'app/events';
import { FIELD_ARRIVAL_CITY } from 'app/storage/fieldNames';
import { TripLocationPicker } from 'app/components/ui/TripLocationPicker';

const mapStateToProps = state => ({
    selected: arrivalCitySelector(state),
    autocompleteResults: autocompleteArrivalCurrentByContinentSelector(state),
    defaultResults: autocompleteArrivalDefaultByContinentSelector(state),
    autocompleteLoading: autocompleteArrivalLoadingSelector(state),
    error: errorArrivalSelector(state),
    direction: 'arrival',
});

const mapDispatchToProps = dispatch => ({
    onChangeLocation: (cityDetails) => {
        dispatch(storeCityDetailRequested(cityDetails));
        dispatch(setArrivalLocation(cityDetails.id));

        // emit external event for tracking/marketing etc
        emitFieldChangedEvent('location.arrival', cityDetails.name);
    },
    onClearAutocomplete: () => dispatch(clearAutocomplete('arrival')),
    onRequestAutocomplete: query => (
        dispatch(requestAutocomplete(query, 'arrival', 'current', true))
    ),
    onRequestDefaultAutocomplete: query => dispatch(requestAutocomplete(query, 'arrival', 'default', true)),
});


export const TripArrivalLocationPicker = compose(
    WithTranslations({
        translationGetLabel: 'to',
    }),
    connect(mapStateToProps, mapDispatchToProps),
    withProps(() => ({
        onOpen: () => emitFieldOpenedEvent(FIELD_ARRIVAL_CITY),
        onClose: () => emitFieldClosedEvent(FIELD_ARRIVAL_CITY),
    })),
)(TripLocationPicker);
